import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WorkOrderNameChangeWarningDialogComponent } from './work-order-name-change-warning-dialog.component';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { TranslateModule } from '@ngx-translate/core';
import { CtButtonModule, CtFrameworkModule } from '@ctsolution/ct-framework';

/**
 * Modulo per il componente dialog di warning modifica nome work order
 * Include il checkbox per salvare la preferenza "non mostrare più"
 */
@NgModule({
  declarations: [
    WorkOrderNameChangeWarningDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule, // Necessario per ngModel nel checkbox
    CtButtonModule,
    MatLegacyDialogModule,
    MatIconModule,
    MatLegacyCheckboxModule, // Necessario per mat-checkbox
    TranslateModule,
    CtFrameworkModule
  ],
  exports: [
    WorkOrderNameChangeWarningDialogComponent
  ]
})
export class WorkOrderNameChangeWarningDialogModule { }
